module.exports = function getResource(label, vars = []) {
    let resources = {
        justArrived: 'Nouvel arrivage',
        bestsellers: 'Meilleurs vendeurs'
    };

    return resources[label];
};
